import { render, staticRenderFns } from "./SkeletonRow.vue?vue&type=template&id=538752d0"
import script from "./SkeletonRow.vue?vue&type=script&lang=js"
export * from "./SkeletonRow.vue?vue&type=script&lang=js"
import style0 from "./SkeletonRow.vue?vue&type=style&index=0&id=538752d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports